package com.essntl.features.category.domain.model

data class CategoryModel(
    val id: String,
    val name: String,
    val createdAt: String,
    val iconUrl: String?,
    val serviceDynamicFields: List<String>?,
    val dynamicFields: List<DynamicField>?,
    val qbCategoryId: String?,
) {

    fun getChangedFields(categoryModel: CategoryModel) =
        CategoryModel(
            id = id,
            createdAt = createdAt,
            name = if (name.lowercase().capitalize() != categoryModel.name.lowercase()
                    .capitalize()
            ) categoryModel.name else "",
            iconUrl = if (iconUrl != categoryModel.iconUrl) categoryModel.iconUrl else null,
            serviceDynamicFields = if (serviceDynamicFields != categoryModel.serviceDynamicFields) categoryModel.serviceDynamicFields else null,
            dynamicFields = if (dynamicFields != categoryModel.dynamicFields) categoryModel.dynamicFields else null,
            qbCategoryId = if (qbCategoryId != categoryModel.qbCategoryId) categoryModel.qbCategoryId else null,
        )

    val isEmpty
        get() = this.copy(id = "", createdAt = "") == empty

    companion object {
        val all =
            CategoryModel(
                id = "All",
                name = "All",
                createdAt = "",
                iconUrl = null,
                serviceDynamicFields = null,
                dynamicFields = null,
                qbCategoryId = null,
            )

        val empty =
            CategoryModel(
                id = "",
                name = "",
                createdAt = "",
                iconUrl = null,
                serviceDynamicFields = null,
                dynamicFields = null,
                qbCategoryId = null,
            )

        const val EXTRA = "Extra"
    }
}
